/**
 * This service is in charge of saving states on multiple page
 * especially on pages with map for now (lsr, nrp, npr)
 */
angular.module(NgAppName).service('StateService', ['$cookies', function($cookies) {
	// get states from cookies
	this.states = $cookies.get('states') ? JSON.parse($cookies.get('states')) : {};

	this.save = function(pageId, state) {
		var expirationDate = moment().add(1, 'day');
		this.states[pageId] = state;
		$cookies.put('states', JSON.stringify(this.states), {expires: expirationDate.toDate()});
	};

	this.saveKey = function(pageId, key, state) {
		var expirationDate = moment().add(1, 'day');

		if (!this.states[pageId]) {
			this.states[pageId] = {};
		}

		this.states[pageId][key] = state;
		$cookies.put('states', JSON.stringify(this.states), {path: '/', expires: expirationDate.toDate()});
	};

	this.remove = function(pageId, key) {
		var expirationDate = moment().add(1, 'day');
		if (this.states[pageId]) {
			if (key && this.states[pageId][key]){
			delete this.states[pageId][key];
			} else {
				delete this.states[pageId];
			}
		}
		$cookies.put('states', JSON.stringify(this.states), {expires: expirationDate.toDate()});
	};


	this.get = function(pageId) {
		if (pageId && this.states[pageId]) {
			return this.states[pageId];
		}
		return undefined;
	};
}]);
